import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { DASHBOARD } from "@/constants/testIds";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState({ brands: 0, locations: 0, users: 0 });

  useEffect(() => {
    (async () => {
      try {
        const { data: brands } = await api.get("/brands");
        let locTotal = 0;
        const memberEmails = new Set();
        for (const b of brands) {
          const [{ data: locs }, { data: members }] = await Promise.all([
            api.get(`/brands/${b.brand_id}/locations`),
            api.get(`/brands/${b.brand_id}/members`),
          ]);
          locTotal += locs.length;
          members.forEach((m) => memberEmails.add(m.email));
        }
        // Include the current user even if no membership row exists yet.
        if (user?.email) memberEmails.add(user.email);
        setStats({ brands: brands.length, locations: locTotal, users: memberEmails.size });
      } catch {
        // leave at zero
      }
    })();
  }, [user]);

  return (
    <div data-testid={DASHBOARD.root}>
      <div className="mb-12">
        <p className="text-xs uppercase tracking-[0.22em] text-[#B5462F] mb-3">Overview</p>
        <h1
          data-testid={DASHBOARD.welcomeHeading}
          className="font-serif text-5xl tracking-tight"
        >
          Welcome, {user?.name?.split(" ")[0] || "there"}.
        </h1>
        <p className="text-base text-[#3D3A35] mt-3 max-w-2xl">
          This is a test environment to determine the best content and rule
          settings to establish for efficient, AI-powered composition of
          brand-compliant marketing materials, in response to requests from
          local marketers. Note that brand data and settings will be wiped
          periodically, without notice, as the solution evolves.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl">
        <StatCard testid={DASHBOARD.brandsCard} label="Brands" value={stats.brands} to="/brands" cta="Manage brands" />
        <StatCard testid={DASHBOARD.usersCard} label="Users" value={stats.users} />
        <StatCard testid={DASHBOARD.locationsCard} label="Locations" value={stats.locations} />
      </div>
    </div>
  );
}

function StatCard({ testid, label, value, to, cta }) {
  const inner = (
    <div className="border border-[#1A1F2C]/10 bg-white rounded-lg p-6 hover:border-[#1A1F2C]/30 transition-colors">
      <div className="text-xs uppercase tracking-[0.2em] text-[#6B6358] mb-3">{label}</div>
      <div className="font-serif text-5xl tracking-tight">{value}</div>
      {cta && <div className="mt-4 text-sm text-[#B5462F]">{cta} &rarr;</div>}
    </div>
  );
  return (
    <div data-testid={testid}>
      {to ? <Link to={to}>{inner}</Link> : inner}
    </div>
  );
}
